export enum DiscountProvider {
  Shopifydiscount = "shopifyDiscount",
  Bigcommercediscount = "bigcommerceDiscount",
}
